let getApi = () => import('@/services/Api');
import chartOptions from '../chart-option-catalog';

const state = {
    options: {},
    series: [],
    type: 'radialBar',
    chartConfigs: {
        asset: {type:'radialBar', options:chartOptions.assetPageOptions},
        employee:{type:'bar', options:chartOptions.employeeChartOptions}
    }
};

const getters = {
    getChartOptions: (state) => state.options,
    getChartSeries: (state) => state.series,
    getChartType: (state) => state.type,
    getChartTypeList:(state)=>(table)=>state.chartConfigs[table.toLowerCase()]
};
const actions = {
    async prepareAssetPageChart({commit, getters, rootGetters, dispatch}, payload) {
        commit('setChartSeries', [0, 0, 0])
        let {type,options} =  getters.getChartTypeList(payload.table)
        commit('setChartType', type)
        options = {
            colors: ['#FF5252', '#2196F3', '#4CAF50'],
            labels: ['Просрочено 0 ', 'На руках 0', 'Выдано на 0'],
        }
        //let options = chartOptions.assetPageOptions
        try {
            const {http} = await getApi();
            const response = await http.getData('/chart/asset/', {assetId: payload.assetId})
            if (response.status === 200 && response.data.chart) {
                commit('setChartSeries', response.data.chart)
                options = {
                    ...options, ...{
                        labels:
                            [
                                `${rootGetters.getTranslation("Просрочено", "asset_overdue")}: ${response.data.info[0]}`,
                                `${rootGetters.getTranslation("На руках", "asset_on_hands")}:${response.data.info[1]}`,
                                `${rootGetters.getTranslation("Выдано на", "asset_issued_total")}:${response.data.info[2]}`
                            ]
                    }
                }
            } else {
                commit('setChartSeries', [0, 0, 0])
            }
        } catch (e) {
            return dispatch('storeError', e)
        }
        commit('setChartOptions', options)
    },
    async prepareEmployeePageChart({commit, getters, dispatch}, payload) {
        commit('setChartSeries', [])
        let {type,options} =  getters.getChartTypeList(payload.table)
        commit('setChartType', type)
        try {
            const {http} = await getApi();
            const response = await http.getData(`chart/Employee/${payload.employeeId}`)
            if (response.status === 200 ) {
                const {categories=[],issuedToList = [], overdueList=[],onHandsList=[]} = response.data.chartOption;

                commit('setChartSeries', [
                    {name: 'Выдано на', data: issuedToList},
                    {name: 'На руках', data: onHandsList},
                    {name: 'Просрочено на', data: overdueList}
                ])

                options.xaxis.categories = categories;

            } else {
                commit('setChartSeries', [0, 0, 0])
            }
        } catch (e) {
            return dispatch('storeError', e)
        }
        commit('setChartOptions', options)
    },
};
const mutations = {
    setChartType: (state, data) => {
        state.type = data;
    },
    setChartOptions: (state, data) => {
        state.options = {...data};
    },
    setChartSeries: (state, data) => {
        state.series = [...data];
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}